import {useEffect, useState} from 'react';
import type {BreakpointsConfig} from './useMediaQuery.types';

export class Breakpoints {
  constructor(private config: BreakpointsConfig) {}
  only(key: keyof BreakpointsConfig) {
    const order: Array<keyof BreakpointsConfig> = [
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
    ];
    let i = order.indexOf(key) + 1;
    while (!this.config[order[i]] && i < order.length) {
      ++i;
    }

    return `(min-width: ${this.config[key]}px)${i < order.length ? ` and (max-width: ${this.config[order[i]]}px)` : ''}`;
  }
  between(
    start: keyof BreakpointsConfig,
    end: keyof BreakpointsConfig,
    startingOffset = 0,
    endingOffset = 0,
  ) {
    return `(min-width: ${(this.config[start] || 0) + startingOffset}px) and (max-width: ${(this.config[end] || 0) + endingOffset}px)`;
  }
  not(key: keyof BreakpointsConfig) {
    return `not(${this.only(key)})`;
  }
  up(key: keyof BreakpointsConfig, offset = 0) {
    return `(min-width: ${(this.config[key] || 0) + offset}px)`;
  }
  down(key: keyof BreakpointsConfig, offset = 0) {
    return `(max-width: ${(this.config[key] || 0) + offset}px)`;
  }
}

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState<boolean>(false);
  useEffect(() => {
    const queryList = window.matchMedia(query);
    setMatches(queryList.matches);
    const onMatchChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };
    queryList.addEventListener('change', onMatchChange);
    return () => {
      queryList.removeEventListener('change', onMatchChange);
    };
  }, [query]);

  return matches;
};
